<template>
    <div class="sr-trace-track">
        <el-dialog
            :visible.sync="dialogVisible"
            width="800px"
            top="5vh"
            append-to-body
            @close="dialogVisible = false"
            class="sr-trace-track-dialog"
        >
            <template slot="title">
                <el-tabs v-model="activeName">
                    <el-tab-pane name="first">
                        <div slot="label">
                            <img
                                width="24px"
                                style="vertical-align: middle"
                                height="auto"
                                :src="`https://jfzgcsdev.jiefanghao.com/front-res/themes/${theme}/images/other/xuanting.png`"
                                alt
                            />
                            <span>留痕轨迹</span>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="second" v-if="imgUrl">
                        <div slot="label">
                            <img
                                width="24px"
                                style="vertical-align: middle"
                                height="auto"
                                :src="`https://jfzgcsdev.jiefanghao.com/front-res/themes/${theme}/images/other/lanmu.png`"
                                alt
                            />
                            <span>流程图</span>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </template>
            <div class="dialog-content">
                <template v-if="activeName == 'first'">
                    <div v-if="newtraclData.length">
                        <el-timeline>
                            <el-timeline-item
                                :color="activity.color"
                                class="track_content"
                                v-for="(activity, index) in newtraclData"
                                :key="index"
                            >
                                <div class="track_title title_track_title">
                                    <span>
                                        {{ activity.name }}
                                    </span>
                                    <div class="title_track_title_box">
                                        <div
                                            class="title_track_item"
                                            v-for="(
                                                list, i
                                            ) in activity.basicList"
                                            :key="i"
                                        >
                                            <div
                                                v-if="
                                                    list.name &&
                                                    list.name.includes('结果')
                                                "
                                            >
                                                <span class="name"
                                                    >{{ list.name }}：</span
                                                >
                                                <i
                                                    :class="[
                                                        list.color === 'SUCCESS'
                                                            ? 'el-icon-success success'
                                                            : 'el-icon-error error',
                                                    ]"
                                                    v-if="
                                                        [
                                                            'SUCCESS',
                                                            'ERROR',
                                                            'FAIL',
                                                        ].includes(list.color)
                                                    "
                                                ></i>
                                                <span
                                                    :class="
                                                        calculateColor(list)
                                                    "
                                                    v-html="list.value"
                                                ></span>
                                            </div>
                                            <div v-else>
                                                <span class="name"
                                                    >{{ list.name }}：</span
                                                >
                                                <span
                                                    class="value"
                                                    v-html="list.value"
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="track_box"
                                    v-if="
                                        activity.extendList &&
                                        activity.extendList.length
                                    "
                                >
                                    <template>
                                        <div
                                            class="track_item"
                                            v-for="(
                                                list, i
                                            ) in activity.extendList"
                                            :key="i"
                                        >
                                            <div v-if="list.fileList">
                                                <span class="name"
                                                    >{{ list.name }}：</span
                                                >
                                                <ul>
                                                    <li
                                                        class="file_item"
                                                        v-for="(
                                                            item, index
                                                        ) in typeof list.fileList ==
                                                        'string'
                                                            ? JSON.parse(
                                                                  list.fileList
                                                              )
                                                            : list.fileList"
                                                        :key="index"
                                                    >
                                                        
                                                        <div class="xian_left" v-if="origin.includes('xian')">
                                                            <i
                                                                class="
                                                                    icon-attachent
                                                                "
                                                            ></i>
                                                            <span
                                                                class="
                                                                    file_name
                                                                "
                                                                :title="
                                                                    item.name ||
                                                                    item.fileName
                                                                "
                                                                >{{
                                                                    item.name ||
                                                                    item.fileName
                                                                }}</span
                                                            >
                                                            <div
                                                                class="time"
                                                                v-if="item.createTime"
                                                            >
                                                                {{
                                                                    item.createTime
                                                                }}
                                                            </div>
                                                            <el-popover
                                                                placement="top"
                                                                width="54"
                                                                trigger="hover"
                                                                content="查看"
                                                            >
                                                                <div
                                                                    class="btn"
                                                                    slot="reference"
                                                                >
                                                                    <i
                                                                        @click="
                                                                            download(
                                                                                item
                                                                            )
                                                                        "
                                                                        class="
                                                                            el-icon-view
                                                                        "
                                                                    ></i>
                                                                </div>
                                                            </el-popover>
                                                            <el-popover
                                                                placement="top"
                                                                width="54"
                                                                trigger="hover"
                                                                content="下载"
                                                            >
                                                                <div
                                                                    class="btn"
                                                                    slot="reference"
                                                                >
                                                                    <i
                                                                        @click="
                                                                            download(
                                                                                item
                                                                            )
                                                                        "
                                                                        class="
                                                                            icon-download
                                                                        "
                                                                    ></i>
                                                                </div>
                                                            </el-popover>
                                                        </div>
                                                        <div
                                                            class="left"
                                                            @click="
                                                                download(item)
                                                            "
                                                            v-else
                                                        >
                                                            <i
                                                                class="
                                                                    icon-attachent
                                                                "
                                                            ></i>
                                                            <span
                                                                class="
                                                                    file_name
                                                                "
                                                                :title="
                                                                    item.name ||
                                                                    item.fileName
                                                                "
                                                                >{{
                                                                    item.name ||
                                                                    item.fileName
                                                                }}</span
                                                            >
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-else>
                                                <div class="name">
                                                    {{ list.name }}：
                                                </div>
                                                <span
                                                    class="value"
                                                    v-html="list.value"
                                                ></span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                    <div class="emptyBox" v-else-if="trackData.length == 0">
                        <img
                            :src="`https://jfzgcsdev.jiefanghao.com/front-res/themes/${theme}/images/other/empty.png`"
                            alt
                        />
                        <div>暂无数据</div>
                    </div>
                </template>

                <template v-if="activeName == 'second'">
                    <viewer
                        style="background: #fff"
                        class="viewer"
                        :images="[`data:text/html;base64,${imgUrl}`]"
                        alt="流程图"
                    >
                        <img
                            class="flow_img"
                            :src="`data:text/html;base64,${imgUrl}`"
                            alt="流程图"
                        />
                    </viewer>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        defaultProps: {
            type: Object,
            default() {
                return {};
            },
        },
        imgUrl: {
            type: String,
            default() {
                return "";
            },
        },
        trackData: {
            type: Array,
            default() {
                return [];
            },
        },
        theme: {
            type: String,
            default() {
                return "default";
            },
        },
    },
    watch: {
        trackData: {
            handler() {
                this.trackDataIsShow();
            },
            deep: true,
        },
    },
    data() {
        return {
            activeName: "first",
            dialogVisible: false,
            newtraclData: [],
        };
    },
    computed: {
        origin() {
            return sessionStorage.getItem('origin') || '';
        },
    },
    methods: {
        download(file) {
            let token = sessionStorage.getItem("token");
            window.open(
                `${window.location.origin}/jfzg/file/api/file/download?key=${file.id}&access_token=${token}`
            );
        },
        //无闪烁跳转
        exportFile(url) {
            let a = document.createElement("a");
            a.href = url;
            a.click();
        },
        calculateColor(item) {
            let color;
            if (item.value == "通过") {
                color = "success";
            } else if (item.value == "不通过") {
                color = "error";
            }

            return color;
        },
        open() {
            this.dialogVisible = true;
        },
        trackDataIsShow() {
            this.newtraclData = this.trackData.map((item) => {
                item.basicList = [];
                item.extendList = [];
                item.list.forEach((res) => {
                    if (["操作人", "操作时间", "审批结果"].includes(res.name)) {
                        item.basicList.push(res);
                    } else {
                        item.extendList.push(res);
                    }
                });
                return item;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// packages/SrTraceTrack/SrTraceTrack.vue